import { FieldError } from "client/lib/apt-merchant";

import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";
import { exactLength, isNumber } from "../../validate";

const errorMessage = "Must enter 9 digit BN (first 9 digits of your tax ID)";

export class CraBusinessNumberField extends Field<string> {
  constructor(model: Merchant, opts: Partial<MerchantField<string>> = {}) {
    super(model, {
      dataType: "string",
      testValue: "123456789",
      propertyName: "craBusinessNumber",
      uiFieldType: "Input",
      ...opts,
    });
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    const businessType = this._model.companyInformation.businessType.value;

    if (
      registeredCountry === "Canada" &&
      businessType !== "Sole Proprietorship"
    ) {
      return true;
    }
    return false;
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }

  _validate(): void {
    if (typeof this.value === "undefined") return;

    if (!exactLength(9)(this.value) || !isNumber(this.value)) {
      throw new FieldError(this, errorMessage, "InvalidLength");
    }
  }
}
